import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { parseHexToRGB } from "../../../../../../../../common-deprecated/utils";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const CenterLabel = styled.div<{ hasText?: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 300px;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 1;
    user-select: none;

    ${({ hasText }) =>
        hasText &&
        css`
            padding: ${theme.space[1]}px ${theme.space[3]}px;
            font-family: ${theme.fonts.book};
            font-size: 1.4rem;
            text-overflow: ellipsis;
            color: ${theme.colors.white};
            white-space: nowrap;
            background-color: rgba(${parseHexToRGB(theme.colors.steel).rgb}, 0.9);
            border-radius: 100px;
        `};

    svg {
        margin-right: ${theme.space[1]}px;
        color: ${theme.colors.white};
        vertical-align: middle;
    }

    @media ${getBreakpoint("up", "md")} {
        max-width: none;
    }

    html[dir="rtl"] & {
        svg {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;
